<template>
  <span v-if="currentLogoData" class="PlatformLogo" :class="currentLogoData.className">
    <img :src="currentLogoData.logoSrc" :alt="currentLogoData.label" />
    {{ currentLogoData.label }}
  </span>
</template>

<script>
export default {
  props: {
    shopType: {
      type: String,
      default: 'B'
    }
  },
  data() {
    return {
      logoList: [
        {
          label: '天猫',
          shopType: 'B',
          logoSrc: require('@/assets/icon/home_tm.png'),
          className: 'tm'
        },
        {
          label: '天猫',
          shopType: 'T',
          logoSrc: require('@/assets/icon/home_tm.png'),
          className: 'tm'
        },
        {
          label: '京东',
          shopType: 'J',
          logoSrc: require('@/assets/icon/home_jd.png'),
          className: 'jd'
        },
        {
          label: '拼多多',
          shopType: 'P',
          logoSrc: require('@/assets/icon/home_pdd.png'),
          className: 'pdd'
        },
        {
          label: '抖音',
          shopType: 'D',
          logoSrc: require('@/assets/icon/home_dy.png'),
          className: 'dy'
        }
      ]
    }
  },
  computed: {
    currentLogoData() {
      return this.logoList.filter((val) => {
        if (val.shopType === this.shopType) {
          return val
        }
      })[0]
    }
  }
}
</script>

<style scoped lang="scss">
.PlatformLogo {
  position: relative;
  top: -1px;
  display: inline-block;
  height: 11px;
  line-height: 11px;
  font-size: 12px;
  padding: 2px 3px;
  background: #ec0536;
  color: transparent;
  border-radius: 3px;
  margin-right: 5px;
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 11px;
  }
  &.tm {
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 12px;
    }
  }
  &.jd {
    background: linear-gradient(to bottom, #f8c96f, #f1a617);
  }
  &.pdd {
    background: linear-gradient(to bottom, #f76f74, #cf0107);
    padding: 2.5px 1.5px;
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 12px;
    }
  }
  &.dy {
    background-color: #000;
  }
}
</style>
